import { Component, Vue } from 'vue-property-decorator'

@Component
export default class HasScope extends Vue {
  protected userHasPermission(scope: string): boolean {
    if (!scope || this.isAdmin) {
      return true;
    }

    if (scope.indexOf('*') !== -1) {
      return this.$store.state.user.scopes.some((userScope: string) => {
        return (userScope as string).match(new RegExp(scope)) !== null;
      });
    }

    return this.$store.state.user.scopes.indexOf(scope) !== -1;
  }

  get isAdmin(): boolean {
    return this.$store.state.user.isAdmin
  }
}
